module.exports = "/static/images/jet-ski-1.jpg";